{
  "messages": {
    "unknown": "Unknown error",
    "unwellEnvironment": "You have been logged out or lost connection to the system. Please try logging in again.",
    "errorTitle": "An error has occurred!",
    "unknownErrorAdminInfo": "An unknown error, or an error without an error message, has occurred. Please contact the system administrator.",
    "someError": "Something went wrong",
    "nameMissing": "Name missing",
    "nothingFound": "Nothing found",
    "articleMissingTitle": "Article document missing",
    "articleMissingDescription": "No article document has been specified. Navigate back to the overview and try again.",
    "embeddedFactboxMissing": "The factbox could not be opened. Navigate back to the overview and try again.",
    "failedFetchingDocument": "Failed to fetch document.",
    "failedUpdatingListRetrying": "Failed to automatically update the list. Retrying in {{seconds}} seconds.",
    "noResultsFound": "No results found",
    "copyError": "Copy error message",
    "validationError": "Validation error",
    "documentTypeMissing": "{{documentType}} missing",
    "documentTypeMissingDescription": "No {{documentType, lowercase}} has been specified. Navigate back to the overview and try again.",
    "couldNotCreateNewFactbox": "Could not create new factbox!",
    "statusChangeforDocumentTypeFailed": "Could not change the status of the {{documentType, lowercase}}! A linked planning could not be found.",
    "scheduleArticleFailed": "Could not schedule article! The time or date has been specified incorrectly.",
    "createQuickArticleFailed": "Error creating quick article.",
    "flashCreationFailed": "The flash could not be created.",
    "createAssignmentError": "The flash has been created. Unfortunately, linking it to a planning failed.",
    "failedToLoadHistory": "An error occurred when fetching the document history.",
    "failedToLoadMetaData": "An error occurred when fetching the metadata.",
    "saveAssignmentError": "Could not save the assignment",
    "createDeliverableError": "Cannot create deliverable",
    "changeStatusError": "Could not change the status. The assignment's publishing time could not be changed in the linked planning.",
    "loadFailed": "Could not load",
    "noDeliverables": "No deliverables",
    "documentCreationFailed": "{{type}} could not be created.",
    "documentCreatedAssignmentFailed": "{{type}} has been created. Unfortunately it could not be linked to a planning."
  },
  "toasts": {
    "couldNotCreateNewEvent": "Could not create new event!",
    "couldNotCreateNewPlanning": "Could not create new planning!",
    "snapshotError": "The planning has been changed locally but could not be saved.",
    "createDeliverableLinkError": "Could not link deliverable",
    "saveError": "Could not save the planning",
    "saveChangeError": "Could not save the change",
    "missingMetadata": "Missing news value or section",
    "missingTimelessCategory": "Missing timeless category",
    "assignmentMoveError": "The assignment could not be moved",
    "assignmentMoveErrorNotLoggedIn": "The assignment could not be moved. You are not logged in.",
    "assignmentMoveErrorTryAgain": "The assignment could not be moved. Please try again.",
    "couldNotSaveAfterMove": "Could not save after move.",
    "getPlanningsFailed": "Could not fetch plannings",
    "getEventsFailed": "Could not fetch events",
    "getSearchResultsFailed": "Could not fetch search results",
    "unableToAutorise": "Unable to authenticate with the image service",
    "showPictureFailed": "Cannot display the image, invalid ID.",
    "sendDataError": "Could not send data",
    "multipleAuthors": "Multiple author documents found, please contact support",
    "unpublishError": "Could not unpublish the document",
    "addAssignmentToPlanningError": "Could not add the assignment to a linked planning",
    "creationFailed": "Failed to create text: {{error}}",
    "fetchDocumentFailed": "Could not fetch document",
    "couldNotScheduleArticle": "Could not schedule article! The time or date has been specified incorrectly.",
    "savedDocumentFailed": "Could not save document",
    "fetchStatusFailed": "An error occurred when fetching the current status. Please try reloading the page.",
    "couldNotChangeStatusReloadBrowser": "An error has occurred, the current status could not be changed! Reload the browser and try again.",
    "couldNotChangeStatus": "An error occurred when changing the current status.",
    "couldNotSaveStatus": "An error occurred when saving the current status.",
    "failedToFillArticleHeadline": "The headline could not be filled in automatically. The assignment title is still used as the article's title.",
    "couldNotFindPlanningSection": "Could not find the section for the planning",
    "authorUpdateFailure": "Could not update author document: {{errorMessage}}",
    "authorSaveFailure": "Could not save author document: {{errorMessage}}",
    "authorCreateFailure": "Could not create author document: Failed to create author doc",
    "authorCreateUndefinedFailed": "Could not create author document: Failed to fetch author document: undefined",
    "couldNotOpenEmbeddedFactbox": "Could not open the factbox. Please navigate back to the overview and try again.",
    "couldNotLoadFactbox": "Could not load factbox. Please try again."
  },
  "systemMessages": {
    "connectionFailed": "Failed to connect to the messaging service, please reload the window."
  }
}
